import logo from "./logo.png";
import "./styles.scss";

export const FintrafficLogo = () => {
  return <img className="logo" src={logo} alt={""} />;
};
